import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type GroupDetailsResponse } from '../services/emailGroupDetailsService'

export interface EmailGroupDetailsState {
  isLoading: boolean
  loadingError: string | null
  groupDetails: GroupDetailsResponse | null
  httpStatus: number | null
}

const initialState: EmailGroupDetailsState = {
  isLoading: true,
  loadingError: null,
  groupDetails: null,
  httpStatus: null
}

const emailGroupDetailsSlice = createSlice({
  name: 'emailGroupDetails',
  initialState,
  reducers: {
    emailGroupDetailsLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        groupDetails: null,
        httpStatus: 0
      }
    },
    emailGroupDetailsUpdateAction: (state, action: PayloadAction<{ data: GroupDetailsResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        groupDetails: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    emailGroupDetailsErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        groupDetails: null,
        httpStatus: action.payload.httpStatus
      }
    },
    emailGroupDetailsResetAction: () => {
      return initialState
    }
  }
})

export const {
  emailGroupDetailsLoadingAction,
  emailGroupDetailsUpdateAction,
  emailGroupDetailsErrorAction,
  emailGroupDetailsResetAction
} = emailGroupDetailsSlice.actions

export default emailGroupDetailsSlice.reducer
